import React, { useState } from "react";
import CommonLayout from "../../layout/CommonLayout";
import CommonMenu from "../../layout/CommonMenu";
import CommonFooter from "../../layout/CommonFooter";
import { Link } from "react-router-dom";

const GNBPURE06001S = () => {
  const [isDepthOpen, setIsDepthOpen] = useState(false); // depth2 메뉴 열림 상태

  return (
    <CommonLayout>
      <CommonMenu />

      <div id="contents" className="container">

        <div className="sub-title bg-type06">
          <h2>인재 채용</h2>
        </div>

        <div className="location_wrap"
          onClick={() => setIsDepthOpen(!isDepthOpen)}>
          <ul className="depth1">
            <li><Link to="/">home</Link></li>
            <li><Link to="/" onClick={(e) => e.preventDefault()}>인재상<span></span></Link>
              <ul className="depth2" style={{ display: isDepthOpen ? "block" : "none" }}>
                <li><Link to="/GNBPURE06001S">인재상</Link></li>
                <li><Link to="/GNBPURE06002S">복리후생</Link></li>
                <li><Link to="/GNBPURE06003S">채용공고</Link></li>
              </ul>
            </li>
          </ul>
        </div>
        <div id="cont" className="cont">
          <div className="inner">
            
            <h3>인재상</h3>
            <div className="talent-container">
              
              <div className="talent-topTitle">
                <p>
                  흥미와 열정을 가진 사람들이 함께할 때 더 빠르게 성장할 수 있습니다.<br />
                  협력과 소통을 바탕으로 새로운 기술을 배우고, 금융 IT의 미래를 만들어갑니다.
                </p>
              </div>

              <div>
                  <h2 className="talent-subtitle">개발을 즐기며 함께 발전하는 사람</h2>
                  <p className="talent-text">
                    처음부터 잘하는 사람은 없어요!<br /> 
                    개발에 흥미를 가지고 꾸준히 성장하려는 마음과<br />
                    금융 업무에 대한 관심과 노력이 있다면,<br />
                    회사 생활을 하다 보면 어느새 “찢었다! 내가 이렇게 잘하는구나!” 라는 생각이 절로 들 거예요.
                  </p>
              </div>
              
              <div className="talent-grid">
                  <div className="talent-item">
                      <h4>소통과 협력을 중시하는 사람</h4>
                      <img src="/asset/img/recruit/icon_communication.png" alt="소통과 협력을 중시하는 사람"/>
                      <p>서로의 의견을 존중하고 원활한 의사소통을 통해 팀워크를 극대화하는 인재</p>
                  </div>
                  <div className="talent-item">
                      <h4>도전하는 사람</h4>
                      <img src="/asset/img/recruit/icon_summit.png" alt="도전하는 사람"/>
                      <p>실패를 두려워하기보다 이를 통해 배우고 발전하는 과정을 즐길 수 있는 인재</p>
                  </div>
                  <div className="talent-item">
                      <h4>높은 적응력</h4>
                      <img src="/asset/img/recruit/icon_adaptability.png" alt="높은 적응력"/>
                      <p>변화하는 환경에서 빠르게 적응하며, 안정적인 업무를 수행하는 인재</p>
                  </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <CommonFooter />
    </CommonLayout>
  );
};

export default GNBPURE06001S;